module.exports = __webpack_public_path__ + "static/media/NANO.9317d7dd.svg";